export default {
  // 加載狀態
  loadingHistory: "正在載入會話內容...",

  // 房間和用戶信息
  aiAssistant: "AI助手",
  aiAssistantXiaoTu: "AI助手--小圖",
  you: "您",
  today: "今天",
  online: "在線",

  // 歡迎語
  welcomeConsult: "歡迎咨詢AI助手",
  welcomeMessageRobot: "您好，我是AI助手--小圖。<br/>請問有什麼可以幫助您的？",
  welcomeMessageFull: `您好！我是智能助手小圖。我融合了大模型的先進AI能力與圖鏈在虛擬幣犯罪追蹤與風險防控領域的深厚實戰經驗，致力於為您提供專業的虛擬貨幣安全與合規支持和產品使用指南。
 您可以問我有任何關於：
• 畫布操作快捷鍵有哪些？
• 畫布支持哪些幣種分析？
• 如何創建案件？
• 如何識別虛擬幣風險？
• 可疑交易模式分析？
• 鏈上追蹤基礎知識？
• ...（其他具體產品功能操作問題或其他虛擬貨幣犯罪、風控、合規、鏈上分析相關問題）`,

  // 聊天組件文本
  textMessages: {
    roomsEmpty: "沒有對話",
    roomEmpty: "沒有選擇對話",
    newMessages: "新消息",
    messageDeleted: "此消息已被刪除",
    messagesEmpty: "沒有消息",
    conversationStarted: "對話開始於：",
    typeMessage: "請輸入您要提問的內容...",
    search: "搜索",
    isOnline: "歡迎咨詢AI助手",
    lastSeen: "最後一次上線 ",
    isTyping: "正在輸入...",
  },

  // 初始問候消息
  initialGreeting: "您好，我是AI助手。<br/>請問有什麼可以幫助您的？",
};
